<template>
  <svg width="27"
       height="27"
       viewBox="0 0 27 27"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.9 21.7827L21.628 21.0533L19.18 18.6053V14.9733H18.1533V19.0347L20.9 21.7827ZM2.15333 21.3333C1.55778 21.3333 1.04978 21.1236 0.629333 20.704C0.209778 20.2844 0 19.7764 0 19.18V2.15333C0 1.55778 0.209778 1.04978 0.629333 0.629333C1.04889 0.209778 1.55689 0 2.15333 0H19.18C19.7756 0 20.2836 0.209778 20.704 0.629333C21.1236 1.04889 21.3333 1.55689 21.3333 2.15333V10.0867C21.0996 10.0067 20.8756 9.94133 20.6613 9.89067C20.448 9.84089 20.2276 9.79111 20 9.74133V2.15467C20 1.94933 19.9147 1.76089 19.744 1.58933C19.5724 1.41867 19.3844 1.33333 19.18 1.33333H2.15333C1.94889 1.33333 1.76089 1.41867 1.58933 1.58933C1.41867 1.76089 1.33333 1.94889 1.33333 2.15333V19.18C1.33333 19.3844 1.41867 19.5724 1.58933 19.744C1.76089 19.9147 1.94889 20 2.15333 20H9.708C9.74 20.2489 9.78133 20.4804 9.832 20.6947C9.88267 20.908 9.948 21.1209 10.028 21.3333H2.15333ZM1.33333 18.6667V20V1.33333V9.74133V9.64133V18.6667ZM4.66667 16.36H9.94667C9.99556 16.1316 10.0622 15.9107 10.1467 15.6973L10.4133 15.0253H4.66667V16.36ZM4.66667 11.3333H13.44C13.8782 11.0258 14.3093 10.7649 14.7333 10.5507C15.1591 10.3373 15.6156 10.1702 16.1027 10.0493V10H4.66667V11.3333ZM4.66667 6.30667H16.6667V4.97333H4.66667V6.30667ZM18.6667 24.1547C17.1813 24.1547 15.9209 23.6373 14.8853 22.6027C13.8498 21.568 13.3324 20.3071 13.3333 18.82C13.3333 17.3356 13.8507 16.0756 14.8853 15.04C15.92 14.0044 17.1804 13.4867 18.6667 13.4867C20.152 13.4867 21.4124 14.0044 22.448 15.04C23.4836 16.0756 24.0009 17.3356 24 18.82C24 20.3062 23.4827 21.5667 22.448 22.6013C21.4116 23.636 20.1511 24.1547 18.6667 24.1547Z"
      fill="url(#paint0_linear_155_2317)" />
    <defs>
      <linearGradient id="paint0_linear_155_2317"
                      x1="13.3333"
                      y1="0"
                      x2="13.3333"
                      y2="26.6667"
                      gradientUnits="userSpaceOnUse">
        <stop :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#59BEE5'}` : color" />
        <stop offset="1" :stop-color="active ? `${$store.state.ui_options.theme?.selected_item_color || '#118EBE'}` : color" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "#899399"
    }
  }
}
</script>
